<template>
    <div class="lista-conversas-base">
        <app-tabela
            :idTabela="tabelaId"
            :itens="conversas"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :busy="carregando"
            :rowClass="getRowClass"
        >
            <template v-slot:acoes="slotProps">
                <span
                    class="text-primary"
                    @click.stop="$emit('abrir-conversa', slotProps.item || slotProps)"
                >
                    <i
                        class="fa fa-comments fa-lg icon-button"
                        title="Visualizar mensagens da conversa"
                    ></i>
                </span>
            </template>
        </app-tabela>

        <modal-conversa
            :modal-id="modalId"
            :conversa-ativa="conversaAtiva"
            :participantes="participantes"
            :deve-exibir-participantes="deveExibirParticipantes"
            :usuario-id="usuarioId"
            :usuario="usuario"
            @modal-hidden="$emit('modal-hidden')"
            @novas-mensagens="$emit('novas-mensagens')"
            @mensagens-marcadas-como-lidas="onMensagensMarcadasComoLidas"
        />
    </div>
</template>

<script>
import ModalConversa from './ModalConversa.vue'

export default {
    name: 'ListaConversasBase',
    
    components: {
        ModalConversa
    },

    props: {
        tabelaId: {
            type: String,
            required: true
        },
        modalId: {
            type: String,
            required: true
        },
        conversas: {
            type: Array,
            default: () => []
        },
        campos: {
            type: Array,
            required: true
        },
        itensPorPagina: {
            type: Number,
            default: 10
        },
        carregando: {
            type: Boolean,
            default: false
        },
        conversaAtiva: {
            type: Object,
            default: null
        },
        participantes: {
            type: Array,
            default: () => []
        },
        deveExibirParticipantes: {
            type: Boolean,
            default: true
        },
        usuarioId: {
            type: String,
            required: true
        },
        usuario: {
            type: String,
            required: true
        }
    },

    methods: {
        getRowClass(item, type) {
            if (!item) return null
            
            const qtdNaoLidas = item.qtdNaoLidas || 0
            const hasNaoLidas = qtdNaoLidas > 0
            
            return hasNaoLidas ? 'conversa-nao-lida' : null
        },

        onMensagensMarcadasComoLidas(evento) {
            this.$emit('mensagens-marcadas-como-lidas', evento)
            
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        }
    }
}
</script>

<style src="../styles/conversas-shared.css"></style>

<style scoped>
/* Estilos específicos para ListaConversasBase com alta especificidade */
.lista-conversas-base >>> .conversa-nao-lida,
.lista-conversas-base ::v-deep .conversa-nao-lida,
.lista-conversas-base :deep(.conversa-nao-lida) {
    font-weight: bold !important;
    background-color: #f8f9fa !important;
}

.lista-conversas-base >>> .conversa-nao-lida td,
.lista-conversas-base ::v-deep .conversa-nao-lida td,
.lista-conversas-base :deep(.conversa-nao-lida td) {
    font-weight: bold !important;
}
</style>
